import { computed } from 'vue'
import { useAuth } from '../auth.js'

const male = 'male'
const female = 'female'

export const you = computed(() => {
  const auth = useAuth()
  const sex = auth.sex || male

  if (sex === female) {
    return '妳'
  }

  return '你'
})
